import { defaultAdminListViewMode, MOBILE_BREAKPOINT_MAX_PX } from '@/utils/media'

/** 列表/卡片随视口宽度切换（≤768px 默认卡片）；用户手动点后不再自动覆盖 */
export default {
  data() {
    return {
      viewMode: defaultAdminListViewMode(),
      viewModeUserPinned: false,
    }
  },
  methods: {
    setViewMode(mode) {
      this.viewModeUserPinned = true
      this.viewMode = mode
    },
    bindAdminListViewModeMedia() {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
      const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT_MAX_PX}px)`)
      const onChange = () => {
        if (this.viewModeUserPinned) return
        const next = mq.matches ? 'grid' : 'list'
        if (this.viewMode !== next) this.viewMode = next
      }
      this._adminListViewModeMq = mq
      this._adminListViewModeMqHandler = onChange
      if (mq.addEventListener) mq.addEventListener('change', onChange)
      else if (mq.addListener) mq.addListener(onChange)
    },
    unbindAdminListViewModeMedia() {
      const mq = this._adminListViewModeMq
      const h = this._adminListViewModeMqHandler
      if (mq && h) {
        if (mq.removeEventListener) mq.removeEventListener('change', h)
        else if (mq.removeListener) mq.removeListener(h)
      }
      this._adminListViewModeMq = null
      this._adminListViewModeMqHandler = null
    },
  },
  mounted() {
    this.bindAdminListViewModeMedia()
  },
  beforeUnmount() {
    this.unbindAdminListViewModeMedia()
  },
}
